import { useEffect, useState, useMemo, useRef } from "react";
import { HandySvg } from "handy-svg";
import { Link, useParams } from "react-router-dom";
import iconLogoTV from "../../assets/images/elems/logo-tv.svg";
import iconLogoMobile from "../../assets/images/elems/logo-mobile-short.svg";
import iconPhone from "../../assets/icons/svg-sprite/phone.svg";
import Footer from "../../sections/footer/footer";
import supportCallback from "../../modules/support-callback";
import CallbackForm from "../../sections/callbackForm/callbackForm";
import { user } from "../../lib/api/api";

const PasswordRecovery = () => {
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState("");
  const [subtitle, setSubtitle] = useState("");
  const { pair = "" } = useParams();

  const parsed = useMemo(() => {
    if (!pair.includes("-")) return null;
    const [user_id, token] = pair.split("-", 2);
    return { user_id, token };
  }, [pair]);

  const calledRef = useRef(false);

  useEffect(() => {
    supportCallback();

    if (calledRef.current) return;
    if (!parsed) {
      setLoading(true);
      setTitle("Пароль от личного кабинета не был изменен.");
      setSubtitle(
        "Возможная причина - ссылка для восстановления пароля устарела или недействительна."
      );
      return;
    }
    const { user_id, token } = parsed;

    if (!user_id || !token) {
      setLoading(true);
      setTitle("Пароль от личного кабинета не был изменен.");
      setSubtitle(
        "Возможная причина - ссылка для восстановления пароля устарела или недействительна."
      );
      return;
    }

    calledRef.current = true;
    const card_id = "00000000000";

    user
      .forgotPassword(card_id, user_id, token)
      .then((res) => {
        setLoading(true);
        const updated = Boolean(res?.updated ?? res?.response?.updated);
        if (updated) {
          setTitle("Новый пароль отправлен на вашу электронную почту.");
          setSubtitle(
            "Рекомендуем изменить временный пароль после входа в личный кабинет!"
          );
        } else {
          setTitle("Пароль от личного кабинета не был изменен.");
          setSubtitle(
            "Возможная причина - ссылка для восстановления пароля устарела или недействительна."
          );
        }
      })
      .catch((err) => {
        setLoading(true);
        setTitle("Пароль от личного кабинета не был изменен.");
        setSubtitle(
          "Возможная причина - ссылка для восстановления пароля устарела или недействительна."
        );
      });
  }, []);

  return (
    <>
      <div className="page">
        <header class="header header--miserable">
          <div class="header__top header__top--grey">
            <div class="header__container header__top-wrap">
              <Link
                className="header__lk-logo-link header__lk-logo-link--tablet"
                to="/"
              >
                <h1 className="visuallyhidden">Телекарта Онлайн</h1>
                <img
                  className="header__logo-tablet"
                  src={iconLogoTV}
                  width="190"
                  height="48"
                  alt="Телекарта логотип"
                />
              </Link>
              <div class="header__right-group">
                <div
                  class="header__phone-full"
                  style={{ marginTop: -9, marginBottom: -9 }}
                >
                  <button
                    class="phone-full js-support-callback-trigger"
                    style={{
                      display: "block",
                      position: "relative",
                      fontSize: 15,
                    }}
                    type="button"
                  >
                    <HandySvg
                      className="svg-icon"
                      src={iconPhone}
                      width="22"
                      height="22"
                      style={{ position: "absolute", left: -34, top: 10 }}
                    />
                    <span class="phone-full__text">8 (800)-100-104-7</span>
                  </button>
                  <button
                    class="phone-full js-support-callback-trigger"
                    style={{
                      display: "block",
                      textAlign: "right",
                      fontSize: 15,
                    }}
                    type="button"
                  >
                    <span
                      class="phone-full__text"
                      style={{ textAlign: "right", letterSpacing: 0.35 }}
                    >
                      8 (495)-781-41-03
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="header__bottom">
            <Link
              className="header__lk-logo-link header__lk-logo-link--mobile"
              to="/"
            >
              <h1 className="visuallyhidden">Телекарта Онлайн</h1>
              <img
                className="header__logo-mobile"
                src={iconLogoMobile}
                width="125"
                height="48"
                alt="Телекарта логотип"
              />
            </Link>
            <button
              class="header__contact-btn header__contact-btn--grey header__contact-btn--mobile bttn js-support-callback-trigger"
              type="button"
            >
              <HandySvg
                className="svg-icon"
                src={iconPhone}
                width="22"
                height="22"
              />
            </button>
          </div>
        </header>
        <main className="page__main">
          {!loading && <div className="preloader__wrapper" />}
          <article
            class="common-article"
            style={
              loading ? {} : { overflow: "hidden", height: "0px", margin: 0 }
            }
          >
            <div class="common-article__container content-columns page-container">
              <div class="common-artcile__main content-columns__main">
                <div class="wysiwyg" style={{ paddingTop: 70 }}>
                  <h2>Восстановление пароля</h2>
                  <p style={{ marginBottom: 5 }}>{title}</p>
                  <p style={{ marginTop: 5 }}>{subtitle}</p>
                </div>
              </div>
            </div>
          </article>
        </main>
        <Footer />
        <CallbackForm />
      </div>
    </>
  );
};

export default PasswordRecovery;
